import { Tooltip, makeStyles } from '@material-ui/core';
import type { Activity } from '../../api/types';

const useStyles = makeStyles(theme => ({
  link: {
    fontWeight: 600,
    color: theme.palette.secondary.main,
    textDecoration: 'none',
  },
  empty: { color: theme.palette.text.disabled },
}));

function activityIssue(activity: Activity) {
  // Legacy read precedence is intentional when both projections are present.
  if (activity.azureWorkItem) {
    const { id, type, title, url } = activity.azureWorkItem;
    return { id, label: `${type}: ${title}`, url };
  }
  if (activity.issue) {
    const { externalId, type, title, url } = activity.issue;
    return { id: externalId, label: `${type ? `${type}: ` : ''}${title}`, url };
  }
  return undefined;
}

export function ActivityIssueCell({ activity }: { activity: Activity }) {
  const classes = useStyles();
  const issue = activityIssue(activity);
  if (!issue) return <span className={classes.empty}>—</span>;
  return (
    <Tooltip title={issue.label} arrow>
      <a
        href={issue.url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={event => event.stopPropagation()}
        className={classes.link}
      >
        #{issue.id}
      </a>
    </Tooltip>
  );
}
